import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "border-top-style"
    }}>{`border-top-style`}</h1>
    <p><strong parentName="p">{`Since`}</strong>{`  UXP v2.0`}</p>
    <p>{`Specifies the `}<a parentName="p" {...{
        "href": "../border-style/"
      }}>{`style`}</a>{` of top border to render.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en/docs/Web/CSS/border-top-style"
      }}>{`https://developer.mozilla.org/en/docs/Web/CSS/border-top-style`}</a>{`  `}</p>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-css"
      }}>{`.button {
    border-top-width: 2px;
    border-top-style: solid;
    border-top-color: white;
}
`}</code></pre>
    <h2 {...{
      "id": "quirks-and-exceptions"
    }}>{`Quirks and Exceptions`}</h2>
    <ul>
      <li parentName="ul">{`Not all Spectrum UXP components allow border overrides.`}</li>
      <li parentName="ul">{`Border styles do not work for specific sides; they can only be applied to the entire element.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      